import React from 'react';
import './App.css';
import Header from './components/Header';
import AuditForm from './components/AuditForm';

function App() {
  return (
    <div className="App">
      <Header />
      <main className="main-content">
        <AuditForm />
      </main>
    </div>
  );
}

export default App;
